import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { AppErrorBoundary } from './AppErrorBoundary';
import { installInstitutionalFetch } from './institutional-fetch';
import './styles.css';
import './pwa';

installInstitutionalFetch();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('No se encontró el contenedor raíz de URBANIK.');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);
